import { Alert, AlertTitle } from "@mui/material";
import { isArray } from "lodash";

export const ErrorContainer = ({
  showErrorContainer: show,
  errorContainerTitle: title,
  errorContainerList: errors = [],
}: any) => {
  if (show) {
    const filterErrors = errors.filter((i: any) => i.reasonNotValid !== null);
    return (
      <Alert severity="error" sx={{ margin: 2 }}>
        <AlertTitle>{title}</AlertTitle>
        {filterErrors?.length !== 0 &&
          <ul>
            {filterErrors && isArray(filterErrors) && filterErrors.map((err: any) => (
              <li key={err.id}>{err.reasonNotValid}</li>
            ))}
          </ul>
        }
      </Alert>
    );
  }

  return null;
};